export enum Names {
  Global = "global-store",
}
